/**
 * プチキャリ 全ページ共通の小さなJS
 *
 * - TOPの「LINE & SNS」セクション（index.json の sns）と、
 *   フッターのSNSアイコンのリンクを新しいタブで開く。
 *   Rise の multicolumn セクションには target の設定が無く、
 *   既存ファイルは編集しない方針のため、ここで後付けする。
 * - お問い合わせページ（page.contact.json）の同意チェック。
 *   チェックするまで送信ボタンを無効にし、同意した旨を
 *   contact[...] の隠し項目として送信内容（通知メール）に含める。
 */
(function () {
  'use strict';

  // ---- ヘッダーの追従状態 ----
  // ヘッダー（sticky）が画面上端に張り付き、その下にコンテンツが潜り込んでいる間だけ
  // .pc-header-stuck を付け、CSS で背景を半透明にする。
  // Rise 標準の .scrolled-past-header は、TOPのようにヘッダーの上にメインビジュアルが
  // あるページで付かないことがあるため自前で判定する。
  // 判定: ヘッダー直後の要素の上端が、ヘッダーの下端より上に来ていれば「追従中」。
  var headerSection = document.querySelector('.section-header');
  var afterHeader = headerSection && headerSection.nextElementSibling;
  if (headerSection && afterHeader) {
    // scroll イベントはブラウザ側で描画単位にまとめられるので、ここで直接判定する（処理は位置の比較2回だけ）
    var updateStuck = function () {
      var stuck = afterHeader.getBoundingClientRect().top < headerSection.getBoundingClientRect().bottom - 1;
      headerSection.classList.toggle('pc-header-stuck', stuck);
    };
    window.addEventListener('scroll', updateStuck, { passive: true });
    window.addEventListener('resize', updateStuck);
    window.addEventListener('load', updateStuck);   // 再読み込みでスクロール位置が復元された場合
    updateStuck();
  }

  // ---- TOP「NEW & PICK UP」の並びをランダムにする（2026-10-28） ----
  // index.json の new-pickup が「すべての商品」から24点を出力し、ここで順番を入れ替える。
  // 表示するのは先頭6点だけ（petite.css の nth-child(n+7) で残りを隠す）。
  // Shopify のページはキャッシュされるため、Liquid ではなく表示のたびにブラウザ側で混ぜる。
  document.querySelectorAll('[id$="__new-pickup"] .product-grid').forEach(function (grid) {
    var items = Array.prototype.slice.call(grid.children);
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = items[i]; items[i] = items[j]; items[j] = tmp;
    }
    items.forEach(function (li, n) {
      grid.appendChild(li);
      // 遅延読み込みの画像が先頭に来たときに読み込みを待たせない
      if (n < 6) li.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    });
  });

  // ---- お問い合わせの同意チェック ----
  var consent = document.querySelector('[data-pc-consent-check]');
  var contactForm = document.getElementById('ContactForm');
  if (consent && contactForm) {
    var submit = contactForm.querySelector('button[type="submit"]');
    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'contact[プライバシーポリシーへの同意]';
    hidden.value = '同意する';
    hidden.disabled = true;
    contactForm.appendChild(hidden);

    var sync = function () {
      var ok = consent.checked;
      if (submit) {
        submit.disabled = !ok;
        submit.setAttribute('aria-disabled', String(!ok));
        submit.classList.toggle('pc-is-disabled', !ok);
      }
      hidden.disabled = !ok;
    };
    consent.addEventListener('change', sync);
    sync();

    // 未同意のまま送信しようとしたら止める（Enterキー対策）
    contactForm.addEventListener('submit', function (e) {
      if (!consent.checked) {
        e.preventDefault();
        consent.focus();
        consent.closest('[data-pc-consent]').classList.add('pc-consent--error');
      }
    });
  }

  var selectors = [
    '[id$="__sns"] a[href^="http"]',   // TOP「LINE & SNS」
    '.list-social a[href^="http"]',    // フッターのSNSアイコン
  ];

  document.querySelectorAll(selectors.join(',')).forEach(function (a) {
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener');
  });

  /* ------------------------------------------------------------
     TOP「FEATURE & JOURNAL」（sections/petite-journal.liquid）
     portal（WordPress）の REST API から新着記事を読み、カードを組み立てる。
     タイトル等は WordPress 側で HTML エスケープ済みの文字列なので、
     テキストとして取り出してから textContent で入れる（innerHTML に直接入れない）。
     ------------------------------------------------------------ */
  function toText(html) {
    var div = document.createElement('div');
    div.innerHTML = html || '';
    return (div.textContent || '').trim();
  }

  function journalCard(post) {
    var embedded = post._embedded || {};
    var media = (embedded['wp:featuredmedia'] || [])[0] || {};
    var sizes = (media.media_details && media.media_details.sizes) || {};
    var img = (sizes.medium_large || sizes.large || sizes.medium || {}).source_url || media.source_url || '';
    var cat = '';
    (embedded['wp:term'] || []).forEach(function (group) {
      (group || []).forEach(function (term) {
        if (!cat && term.taxonomy === 'category') cat = term.name;
      });
    });
    var date = (post.date || '').slice(0, 10).replace(/-/g, '.');

    var li = document.createElement('li');
    li.className = 'pc-journal__card';
    var a = document.createElement('a');
    a.href = post.link;
    a.className = 'pc-journal__link';

    var thumb = document.createElement('span');
    thumb.className = 'pc-journal__thumb';
    if (img) {
      var im = document.createElement('img');
      im.src = img;
      im.alt = '';
      im.loading = 'lazy';
      im.decoding = 'async';
      thumb.appendChild(im);
    }
    a.appendChild(thumb);

    if (cat) {
      var c = document.createElement('span');
      c.className = 'pc-journal__cat';
      c.textContent = cat;
      a.appendChild(c);
    }
    var t = document.createElement('span');
    t.className = 'pc-journal__name';
    t.textContent = toText(post.title && post.title.rendered);
    a.appendChild(t);

    var d = document.createElement('time');
    d.className = 'pc-journal__date';
    d.dateTime = post.date || '';
    d.textContent = date;
    a.appendChild(d);

    li.appendChild(a);
    return li;
  }

  document.querySelectorAll('[data-pc-journal]').forEach(function (root) {
    var list = root.querySelector('[data-pc-journal-list]');
    var count = parseInt(root.getAttribute('data-count'), 10) || 3;
    var url = root.getAttribute('data-api') +
      '?per_page=' + count + '&_embed=wp:featuredmedia,wp:term' +
      '&_fields=link,title,date,_links,_embedded';

    fetch(url, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then(function (posts) {
        list.innerHTML = '';
        (posts || []).forEach(function (post) { list.appendChild(journalCard(post)); });
        if (!list.children.length) list.hidden = true;
      })
      .catch(function () {
        list.hidden = true; // 読み込めないときは見出しと「すべて見る」だけ残す
      })
      .finally(function () {
        list.removeAttribute('aria-busy');
      });
  });
})();
